import Icon from "@ant-design/icons";
// eslint-disable-next-line no-restricted-imports
import { useRouter } from "next/router";
import { FunctionComponent, ReactElement } from "react";
import RivalsButton from "rivals/components/shared/Button";
import CheckMark from "rivals/components/shared/Icons/CheckMark";
import { gaEvent, gaTimeout } from "rivals/shared/analytics";
import { CUSTOM_EVENTS } from "rivals/shared/analytics/customEvents";
import { PATHS } from "rivals/shared/constants";
import { setData } from "rivals/shared/utils/qa";
import styles from "./SubscribeToday.module.scss";
import strings from "./strings";

const SubscribeToday: FunctionComponent = (): ReactElement | null => {
  const {
    buttonText,
    header,
    callToJoin,
    valueProp1,
    valueProp2,
    valueProp3,
    valueProp4,
    valueProp5
  } = strings;

  const valueProps = [
    valueProp1,
    valueProp2,
    valueProp3,
    valueProp4,
    valueProp5
  ];

  const router = useRouter();

  return (
    <div className={styles.container} {...setData("subscribe-today-box")}>
      <div className={styles.header}>
        <h2 {...setData("subscribe-today-header")}>{header}</h2>
        <ul>
          {valueProps.map((valueProp, idx) => (
            <li key={idx}>
              <div>
                <Icon
                  component={CheckMark}
                  {...setData(
                    "subscribe-today-checkmark",
                    (idx + 1).toString()
                  )}
                  rev={""}
                  style={{ color: styles.lima, fontSize: "16px" }}
                  translate="yes"
                />
              </div>
              <div
                className={styles.valueProp}
                {...setData("subscribe-today-benefit", (idx + 1).toString())}
              >
                {valueProp}
              </div>
            </li>
          ))}
        </ul>
        <div className={styles.pushDown}>
          <RivalsButton
            buttonText={buttonText}
            className={styles.subscribeTodayButton}
            data="subscribe-today"
            inverted
            onClick={(): void => {
              const clickNavigationEvent = CUSTOM_EVENTS.clickNavigation(
                PATHS.SIGN_UP,
                buttonText
              );
              gaEvent({
                ...clickNavigationEvent,
                eventParams: {
                  ...clickNavigationEvent.eventParams,
                  eventCallback: gaTimeout(() => {
                    router.push(PATHS.SIGN_UP);
                  })
                }
              });
            }}
          />
        </div>
      </div>
      <div className={styles.footer}>
        <span {...setData("subscribe-today-join-millions")}>{callToJoin}</span>
      </div>
    </div>
  );
};

export default SubscribeToday;
